import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export const PRODUCTS_REPORT_LIMIT = 50;

export function productsReportQueryOptions(storeId: string, { from, to }: DayRange) {
  return queryOptions({
    queryKey: reportKeys.products(storeId, { from, to }, PRODUCTS_REPORT_LIMIT),
    queryFn: () => reportsApi.products(storeId, { from, to }, PRODUCTS_REPORT_LIMIT),
    placeholderData: keepPreviousData,
  });
}

export function useProductsReport(storeId: string, range: DayRange) {
  return useQuery(productsReportQueryOptions(storeId, range));
}
